import { useEffect } from 'react';

type Props = {
	title: string;
};

export const PageTitle = (props: Props) => {
	const { title } = props;

	useEffect(() => {
		document.title = title;
	}, [title]);

	return null;
};
